import { fromJS, List } from 'immutable';
import ACTIONS from '../app.constants';
import { Application } from '../modules/application/types';
import { CalendarReducerActionType, CalendarReducer, EventList } from '../modules/calendar/types';

export default function calendarReducer(state = fromJS({}), action: CalendarReducerActionType): CalendarReducer {
    switch (action.type) {
        case ACTIONS.GET_EVENT_LIST.PENDING: {
            return state.setIn(['eventList', 'loading'], true);
        }
        case ACTIONS.GET_EVENT_LIST.SUCCESS: {
            let loadedList = state.getIn(['eventList', 'data']) ?? [];

            const eventList: EventList = action.data as EventList;
            if (loadedList && action.skip > 0) {
                loadedList = loadedList.concat(eventList);
            } else {
                loadedList = eventList;
            }
            return state
                .setIn(['eventList', 'data'], loadedList)
                .setIn(['eventList', 'loadMore'], loadedList.length)
                .setIn(['eventList', 'loading'], false)
                .setIn(['eventList', 'filterLoading'], false);
        }
        case ACTIONS.GET_EVENT_LIST.ERROR: {
            return state.setIn(['eventList', 'loading'], false).setIn(['eventList', 'filterLoading'], false);
        }

        case ACTIONS.SET_EVENT_LIST_COUNT.PENDING: {
            return state.setIn(['eventList', 'loading'], false).setIn(['eventList'], []);
        }
        case ACTIONS.SET_EVENT_LIST_COUNT.SUCCESS: {
            return state.setIn(['eventList', 'eventCount'], action.eventCount);
        }
        case ACTIONS.SET_EVENT_LIST_COUNT.ERROR: {
            return state.setIn(['eventList', 'loading'], false).setIn(['eventList'], []);
        }

        case ACTIONS.CHANGE_EVENT_FILTERS: {
            return state.setIn(['eventFilters', 'filterSelections'], action.payload.data);
        }

        case ACTIONS.DOWNLOAD_INSPECTOR_PACKET.PENDING: {
            return state.setIn(['templates', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.DOWNLOAD_INSPECTOR_PACKET.SUCCESS: {
            return state.setIn(['templates', 'loading'], false);
        }
        case ACTIONS.DOWNLOAD_INSPECTOR_PACKET.ERROR: {
            return state.setIn(['templates', 'loading'], false);
        }
        case ACTIONS.GET_SPECIFIC_LICENSES.PENDING: {
            return state.setIn(['appointmentLicenses', 'loading'], action.status === 'LOADING' ? true : false);
        }
        case ACTIONS.GET_SPECIFIC_LICENSES.SUCCESS: {
            return state
                .setIn(['appointmentLicenses', 'loading'], false)
                .setIn(['appointmentLicenses', 'data'], action.data);
        }
        case ACTIONS.GET_SPECIFIC_LICENSES.ERROR: {
            return state.setIn(['appointmentLicenses', 'loading'], false);
        }
        case ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT.PENDING: {
            return state.setIn(['linkedLicenses', 'loading'], true);
        }
        case ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT.SUCCESS: {
            return state.setIn(['linkedLicenses', 'loading'], false).setIn(['linkedLicenses', 'data'], action.data);
        }
        case ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT.ERROR: {
            return state.setIn(['linkedLicenses', 'loading'], false);
        }

        case ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT.PENDING: {
            return state.setIn(['personLicenses', 'loading'], true);
        }
        case ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT.SUCCESS: {
            return state.setIn(['personLicenses', 'loading'], false).setIn(['personLicenses', 'data'], action.data);
        }
        case ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT.ERROR: {
            return state.setIn(['personLicenses', 'loading'], false);
        }
        case ACTIONS.ADD_LICENSES_FOR_APPOINTMENT.PENDING: {
            return state.setIn(['appointmentLicenses', 'loading'], true);
        }
        case ACTIONS.ADD_LICENSES_FOR_APPOINTMENT.SUCCESS: {
            const appointmentLicenses = state.getIn(['appointmentLicenses', 'data']) || List();
            return state
                .setIn(['appointmentLicenses', 'loading'], false)
                .setIn(['appointmentLicenses', 'data'], appointmentLicenses.concat(action.data));
        }
        case ACTIONS.ADD_LICENSES_FOR_APPOINTMENT.ERROR: {
            return state.setIn(['appointmentLicenses', 'loading'], false);
        }
        case ACTIONS.GET_CALENDAR_SEARCH_FORM.PENDING: {
            return state.setIn(['calendarSearchForm', 'loading'], true);
        }

        case ACTIONS.GET_CALENDAR_SEARCH_FORM.SUCCESS: {
            return state
                .setIn(['calendarSearchForm', 'loading'], false)
                .setIn(['calendarSearchForm', 'data'], action.data);
        }

        case ACTIONS.GET_CALENDAR_SEARCH_FORM.ERROR: {
            return state.setIn(['calendarSearchForm', 'loading'], false);
        }
        case ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT.PENDING: {
            return state.setIn(['appointmentLicenses', 'loading'], true);
        }
        case ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT.SUCCESS: {
            const licenseId = action.payload.licenseId;
            const appointmentLicenses = state.getIn(['appointmentLicenses', 'data']);
            return state.setIn(['appointmentLicenses', 'loading'], false).setIn(
                ['appointmentLicenses', 'data'],
                appointmentLicenses.filter((appointmentLicense: Application) => appointmentLicense.id !== licenseId),
            );
        }
        case ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT.ERROR: {
            return state.setIn(['appointmentLicenses', 'loading'], false);
        }
    }

    return state;
}
